import { ActionRowProps } from '../../components/kopiliot-list/type'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import { Notification } from '../../shared/models/notification.model'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import SubtleBadge from '../../components/common/SubtleBadge'
import { formatDate } from '../../helpers/utls'

const getColumnsForTableNotifications = (actionRows: ActionRowProps[]) => {
  const columnHelper = createColumnHelper<Notification>()
  const columns: ColumnDef<Notification, string>[] = [
    columnHelper.accessor((row) => row.id?.id, {
      id: 'id',
      cell: (info) => info.getValue(),
      header: () => 'Id',
    }),
    columnHelper.display({
      id: 'name',
      header: () => 'Nom',
      enableSorting: true,
      meta: {
        className: 'align-middle',
      },
      cell: (props) => {
        const { id, subject } = props.row.original

        return (
          <h5 className={'mb-0 fs-10'}>
            <Link to={id ? `${id.id}` : '#'} className={'fw-semibold'}>
              {subject}
            </Link>
          </h5>
        )
      },
    }),
    columnHelper.display({
      id: 'date',
      header: () => 'Date',
      enableSorting: true,
      meta: {
        className: 'align-middle',
      },
      cell: (props) => {
        const { createdAt } = props.row.original

        return createdAt ? formatDate(createdAt, false) : null
      },
    }),
    columnHelper.display({
      id: 'status',
      header: () => 'Status',
      enableSorting: true,
      meta: {
        className: 'align-middle',
      },
      cell: (props) => {
        const { status } = props.row.original

        return (
          <div
            style={{
              maxWidth: '100px',
            }}
          >
            <SubtleBadge
              pill
              className={'d-block'}
              bg={status == 'SENT' ? 'danger' : 'success'}
            >
              {status.toUpperCase()}
              <FontAwesomeIcon
                icon={status ? 'check' : 'times'}
                transform="shrink-2"
                className={'ms-1'}
              />
            </SubtleBadge>
          </div>
        )
      },
    }),
    columnHelper.display({
      id: 'readAt',
      header: () => 'Vu à',
      enableSorting: true,
      meta: {
        className: 'align-middle',
      },
      cell: (props) => {
        const { createdAt, updatedAt } = props.row.original
        if (createdAt && updatedAt && createdAt !== updatedAt) {
          return formatDate(updatedAt, false) ?? null
        }
      },
    }),

    columnHelper.display({
      id: 'actions',
      cell: (props) => {
        const notificationID = props.row.original.id?.id
        return (
          <>
            {actionRows && notificationID && (
              <Dropdown
                className={'text-center btn-reveal-trigger'}
                onClick={(event) => event.stopPropagation()}
              >
                <Dropdown.Toggle
                  size={'sm'}
                  className={'btn-reveal'}
                  variant="falcon-default"
                  id="dropdown-assets-actions"
                >
                  <FontAwesomeIcon icon={'ellipsis-h'} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  popperConfig={{ strategy: 'fixed' }}
                  renderOnMount={true}
                >
                  {actionRows.map((item) => {
                    return (
                      <Dropdown.Item
                        className={`text-${item.color || 'primary'}`}
                        key={item.title}
                        onClick={() => {
                          if (item.onClick) {
                            item.onClick(notificationID)
                          }
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="fs-0 me-2"
                        />
                        {item.title}
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </>
        )
      },
      header: () => 'Actions',
    }),
  ]
  return columns
}

const defaultNotificationActionsRow = (onDeleteItem: (id: string) => void) => {
  const actionsRow: ActionRowProps[] = [
    {
      title: 'Marquer comme lu',
      color: 'primary',
      icon: 'edit',
      onClick: (id) => {
        onDeleteItem(id)
      },
    },
  ]
  return actionsRow
}

export { getColumnsForTableNotifications, defaultNotificationActionsRow }
